module.exports = __webpack_public_path__ + "img/icon_ks+ksvipslt.96a73c4e.png";